var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  preserveAspectRatio: "xMidYMid",
  style: {
    shapeRendering: "auto",
    display: "block",
    background: "0 0"
  },
  viewBox: "0 0 100 100"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#033b6c"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "0s",
  calcMode: "spline",
  dur: "0.9615384615384615s",
  keySplines: "0 0.5 0.5 1",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "10;0"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  begin: "0s",
  calcMode: "discrete",
  dur: "3.846153846153846s",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "#033b6c;#fb8b23;#033b6c;#fb8b23;#033b6c"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#033b6c"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "0s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "0;0;10;10;10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  begin: "0s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "16;16;16;50;84"
}))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 10,
  fill: "#fb8b23"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "-0.9615384615384615s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "0;0;10;10;10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  begin: "-0.9615384615384615s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "16;16;16;50;84"
}))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#033b6c"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "-1.923076923076923s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "0;0;10;10;10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  begin: "-1.923076923076923s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "16;16;16;50;84"
}))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#fb8b23"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "-2.8846153846153846s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "0;0;10;10;10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  begin: "-2.8846153846153846s",
  calcMode: "spline",
  dur: "3.846153846153846s",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  keyTimes: "0;0.25;0.5;0.75;1",
  repeatCount: "indefinite",
  values: "16;16;16;50;84"
}))));
export { SvgLoader as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCIgd2lkdGg9IjM3IiBoZWlnaHQ9IjM3IiBzdHlsZT0ic2hhcGUtcmVuZGVyaW5nOiBhdXRvOyBkaXNwbGF5OiBibG9jazsgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PGNpcmNsZSBmaWxsPSIjMDMzYjZjIiByPSIxMCIgY3k9IjUwIiBjeD0iODQiPgogICAgPGFuaW1hdGUgYmVnaW49IjBzIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMSIgdmFsdWVzPSIxMDswIiBrZXlUaW1lcz0iMDsxIiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjAuOTYxNTM4NDYxNTM4NDYxNXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBhdHRyaWJ1dGVOYW1lPSJyIj48L2FuaW1hdGU+CiAgICA8YW5pbWF0ZSBiZWdpbj0iMHMiIHZhbHVlcz0iIzAzM2I2YzsjZmI4YjIzOyMwMzNiNmM7I2ZiOGIyMzsjMDMzYjZjIiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIGNhbGNNb2RlPSJkaXNjcmV0ZSIgZHVyPSIzLjg0NjE1Mzg0NjE1Mzg0NnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBhdHRyaWJ1dGVOYW1lPSJmaWxsIj48L2FuaW1hdGU+CjwvY2lyY2xlPjxjaXJjbGUgZmlsbD0iIzAzM2I2YyIgcj0iMTAiIGN5PSI1MCIgY3g9IjE2Ij4KICA8YW5pbWF0ZSBiZWdpbj0iMHMiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxIiB2YWx1ZXM9IjA7MDsxMDsxMDsxMCIga2V5VGltZXM9IjA7MC4yNTswLjU7MC43NTsxIiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjMuODQ2MTUzODQ2MTUzODQ2cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGF0dHJpYnV0ZU5hbWU9InIiPjwvYW5pbWF0ZT4KICA8YW5pbWF0ZSBiZWdpbj0iMHMiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxIiB2YWx1ZXM9IjE2OzE2OzE2OzUwOzg0IiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIGNhbGNNb2RlPSJzcGxpbmUiIGR1cj0iMy44NDYxNTM4NDYxNTM4NDZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgYXR0cmlidXRlTmFtZT0iY3giPjwvYW5pbWF0ZT4KPC9jaXJjbGU+PGNpcmNsZSBmaWxsPSIjZmI4YjIzIiByPSIxMCIgY3k9IjUwIiBjeD0iNTAiPgogIDxhbmltYXRlIGJlZ2luPSItMC45NjE1Mzg0NjE1Mzg0NjE1cyIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIHZhbHVlcz0iMDswOzEwOzEwOzEwIiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIGNhbGNNb2RlPSJzcGxpbmUiIGR1cj0iMy44NDYxNTM4NDYxNTM4NDZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgYXR0cmlidXRlTmFtZT0iciI+PC9hbmltYXRlPgogIDxhbmltYXRlIGJlZ2luPSItMC45NjE1Mzg0NjE1Mzg0NjE1cyIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIHZhbHVlcz0iMTY7MTY7MTY7NTA7ODQiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIzLjg0NjE1Mzg0NjE1Mzg0NnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBhdHRyaWJ1dGVOYW1lPSJjeCI+PC9hbmltYXRlPgo8L2NpcmNsZT48Y2lyY2xlIGZpbGw9IiMwMzNiNmMiIHI9IjEwIiBjeT0iNTAiIGN4PSI4NCI+CiAgPGFuaW1hdGUgYmVnaW49Ii0xLjkyMzA3NjkyMzA3NjkyM3MiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxIiB2YWx1ZXM9IjA7MDsxMDsxMDsxMCIga2V5VGltZXM9IjA7MC4yNTswLjU7MC43NTsxIiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjMuODQ2MTUzODQ2MTUzODQ2cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGF0dHJpYnV0ZU5hbWU9InIiPjwvYW5pbWF0ZT4KICA8YW5pbWF0ZSBiZWdpbj0iLTEuOTIzMDc2OTIzMDc2OTIzcyIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIHZhbHVlcz0iMTY7MTY7MTY7NTA7ODQiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIzLjg0NjE1Mzg0NjE1Mzg0NnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBhdHRyaWJ1dGVOYW1lPSJjeCI+PC9hbmltYXRlPgo8L2NpcmNsZT48Y2lyY2xlIGZpbGw9IiNmYjhiMjMiIHI9IjEwIiBjeT0iNTAiIGN4PSIxNiI+CiAgPGFuaW1hdGUgYmVnaW49Ii0yLjg4NDYxNTM4NDYxNTM4NDZzIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMSIgdmFsdWVzPSIwOzA7MTA7MTA7MTAiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIzLjg0NjE1Mzg0NjE1Mzg0NnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBhdHRyaWJ1dGVOYW1lPSJyIj48L2FuaW1hdGU+CiAgPGFuaW1hdGUgYmVnaW49Ii0yLjg4NDYxNTM4NDYxNTM4NDZzIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMSIgdmFsdWVzPSIxNjsxNjsxNjs1MDs4NCIga2V5VGltZXM9IjA7MC4yNTswLjU7MC43NTsxIiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjMuODQ2MTUzODQ2MTUzODQ2cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGF0dHJpYnV0ZU5hbWU9ImN4Ij48L2FuaW1hdGU+CjwvY2lyY2xlPjxnPjwvZz48L2c+PCEtLSBbbGRpb10gZ2VuZXJhdGVkIGJ5IGh0dHBzOi8vbG9hZGluZy5pbyAtLT48L3N2Zz4=";